/**
 * Extracts and validates a redirect path from URL search params.
 * Prevents open redirect attacks by ensuring the path:
 * - Starts with '/'
 * - Does not contain '://' (no scheme injection)
 * - Is not empty
 *
 * Returns the validated path or null if invalid/absent.
 */
export function getValidRedirect(searchParams) {
  const redirect = searchParams.get('redirect');
  if (
    redirect &&
    redirect.startsWith('/') &&
    !redirect.includes('://')
  ) {
    return decodeURIComponent(redirect);
  }
  return null;
}
